<template>
  <div class="boolean">
    <el-form ref="form" label-width="70px" :model="form" :rules="rules">
      <el-form-item label="题干" prop="question">
        <el-input
          v-model="form.question"
          type="textarea"
          :autosize="{ minRows: 1 }"
          resize="none"
          placeholder="请输入题干"
          :readonly="!isEdit"
        />
      </el-form-item>
      <el-form-item label="选项" prop="optionList">
        <b class="tips" style="color: #999" v-show="isEdit"
          >(点击英文字母设置正确答案)</b
        >
        <div class="option" v-for="i in form.optionList" :key="i.tag">
          <span
            class="tag"
            :class="{ checked_tag: isInArray(form.answerList, i.tag) }"
            @click="chooseQuestion(i)"
            >{{ i.tag }}</span
          >
          <span class="option_text">{{ i.option }}</span>
        </div>
      </el-form-item>
      <el-form-item label="分值" prop="score" v-if="!noScore">
        <el-input-number
          v-model="form.score"
          size="small"
          :min="0"
          :controls="false"
        ></el-input-number>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "boolean",
  props: {
    form: Object,
    noScore: Boolean,
    isEdit: Boolean,
  },
  data() {
    return {
      rules: {
        question: [
          { required: true, message: "题干不能为空", trigger: "blur" },
        ],
        optionList: [
          { required: true, message: "选项不能为空", trigger: "change" },
        ],
        score: [{ required: true, message: "分值不能为空", trigger: "change" }],
      },
    };
  },
  methods: {
    isInArray(arr, item) {
      return arr.some((e) => e === item);
    },
    chooseQuestion(item) {
      if (!this.isEdit) return;
      this.form.answerList = [];
      this.form.answerList.push(item.tag);
    },
    checkOption() {
      if (this.form.answerList.length == 0) {
        this.$message.error("请选择答案");
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.option {
  margin-top: 10px;
}
.tag {
  display: inline-block;
  width: 38px;
  text-align: center;
  line-height: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #e6e6e6;
  cursor: pointer;
}
.option_text {
  margin-left: 10px;
}
.checked_tag {
  background: #e5f1ff;
  color: teal;
  border-color: #e5f1ff !important;
}
</style>